export default __webpack_public_path__ + "static/hero_3-35ef43737f52a9094ce5f1b1689ed7c2.jpg";